export interface ConservationLaw {
  readonly name: string;
  readonly shortName: string;
  readonly lhs: number | null;
  readonly rhs: number | null;
  readonly match: boolean;
  readonly interpretation: string;
}

export const CONSERVATION_LAWS: readonly ConservationLaw[] = [
  {
    name: "exp(tr(X)) = det(exp(X))",
    shortName: "Jacobi (BOP Conservation)",
    lhs: 20.0855,
    rhs: 20.0855,
    match: true,
    interpretation: "Local consumption rate determines global obligation exactly",
  },
  {
    name: "tr(AB) = tr(BA)",
    shortName: "Trace Cyclicity",
    lhs: 4.7321,
    rhs: 4.7321,
    match: true,
    interpretation: "Composition order does not affect total resource cost",
  },
  {
    name: "det(AB) = det(A)·det(B)",
    shortName: "Det Multiplicativity",
    lhs: 3.0,
    rhs: 3.0,
    match: true,
    interpretation: "Total obligation factors across composed systems",
  },
  {
    name: "σ(PAP⁻¹) = σ(A)",
    shortName: "Spectral Invariance",
    lhs: null,
    rhs: null,
    match: true,
    interpretation: "Governance meaning preserved under representation change",
  },
];

export function everyConservationLawHolds(laws: readonly ConservationLaw[]): boolean {
  return laws.every((law) => law.match);
}
